/* global axios */
import ApiClient from './ApiClient';

class InternalChatAPI extends ApiClient {
  constructor() {
    super('internal_chat/threads', { accountScoped: true, apiVersion: 'v1' });
  }

  getThreads() {
    return axios.get(this.url);
  }

  createDirect(userId) {
    return axios.post(this.url, { user_id: userId });
  }

  createTeam(teamId) {
    return axios.post(this.url, { team_id: teamId });
  }

  getMessages(threadId, before) {
    return axios.get(`${this.url}/${threadId}/messages`, { params: { before } });
  }

  sendMessage(threadId, content) {
    return axios.post(`${this.url}/${threadId}/messages`, { content });
  }

  markRead(threadId) {
    return axios.post(`${this.url}/${threadId}/read`);
  }
}

export default new InternalChatAPI();
